import {Link} from 'react-router-dom';
import styled from 'styled-components';

interface Props {
	slug: string;
}

const Nav = styled.nav`
	display: flex;
	align-items: center;
	gap: 6px;
	font: ${p => p.theme.ticketing.font.subheading2};
	color: #64748b;
`;
const CrumbLink = styled(Link)`
	color: inherit;
	text-decoration: none;
	&:hover {
		color: #334155;
		text-decoration: underline;
	}
`;
const Current = styled.span`
	font-weight: 500;
	color: #334155;
`;

export function TicketBreadcrumb({slug}: Props) {
	return (
		<Nav aria-label="Breadcrumb">
			<CrumbLink to="/tickets">All tickets</CrumbLink>
			<span aria-hidden="true">/</span>
			<Current>{slug}</Current>
		</Nav>
	);
}
